"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Autocomplete", {
    enumerable: true,
    get: function() {
        return Autocomplete;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _downshift = require("downshift");
var _reactutils = require("@chakra-ui/react-utils");
var _react1 = require("@chakra-ui/react");
var _media = require("../../media/index");
var _Box = require("../../layouts/Box/index");
var _Input = require("../Input/index");
var _typography = require("../../typography/index");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _createContext = _sliced_to_array((0, _reactutils.createContext)({}), 2), AutocompleteProvider = _createContext[0], useAutocompleteContext = _createContext[1];
var stateReducer = function() {
    var minCharsToShowList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return function(_state, actionAndChanges) {
        var type = actionAndChanges.type, changes = actionAndChanges.changes;
        switch(type){
            case _downshift.useCombobox.stateChangeTypes.InputFocus:
            case _downshift.useCombobox.stateChangeTypes.InputChange:
                var _changes_inputValue;
                return _object_spread_props(_object_spread({}, changes), {
                    isOpen: ((_changes_inputValue = changes.inputValue) === null || _changes_inputValue === void 0 ? void 0 : _changes_inputValue.length) >= minCharsToShowList
                });
            default:
                return changes;
        }
    };
};
var Autocomplete = function(_param) {
    var children = _param.children, items = _param.items, onInputValueChange = _param.onInputValueChange, minCharsToShowList = _param.minCharsToShowList, rest = _object_without_properties(_param, [
        "children",
        "items",
        "onInputValueChange",
        "minCharsToShowList"
    ]);
    var _useCombobox = (0, _downshift.useCombobox)(_object_spread({
        items: items,
        onInputValueChange: onInputValueChange,
        stateReducer: stateReducer(minCharsToShowList)
    }, rest)), isOpen = _useCombobox.isOpen, getMenuProps = _useCombobox.getMenuProps, getInputProps = _useCombobox.getInputProps, getItemProps = _useCombobox.getItemProps, selectedItem = _useCombobox.selectedItem, highlightedIndex = _useCombobox.highlightedIndex, reset = _useCombobox.reset;
    return _react.default.createElement(AutocompleteProvider, {
        value: {
            isOpen: isOpen,
            items: items,
            getMenuProps: getMenuProps,
            getInputProps: getInputProps,
            getItemProps: getItemProps,
            selectedItem: selectedItem,
            highlightedIndex: highlightedIndex,
            reset: reset
        }
    }, _react.default.createElement(_Box.Box, {
        position: "relative"
    }, children));
};
var AutocompleteInput = function(_param) {
    var _param_clearButtonMode = _param.clearButtonMode, clearButtonMode = _param_clearButtonMode === void 0 ? "item-selected" : _param_clearButtonMode, rest = _object_without_properties(_param, [
        "clearButtonMode"
    ]);
    var _useAutocompleteContext = useAutocompleteContext(), selectedItem = _useAutocompleteContext.selectedItem, reset = _useAutocompleteContext.reset, getInputProps = _useAutocompleteContext.getInputProps;
    var ref = (0, _react.useRef)(null);
    var inputProps = getInputProps({
        ref: ref
    });
    var clearButtonConditions = {
        "item-selected": selectedItem,
        "has-value": inputProps.value,
        never: false,
        always: true
    };
    var shouldShowClearButton = clearButtonConditions[clearButtonMode];
    var onReset = (0, _react.useCallback)(function() {
        var _reset, _ref_current_focus, _ref_current, _ref;
        (_reset = reset) === null || _reset === void 0 ? void 0 : _reset();
        (_ref = ref) === null || _ref === void 0 ? void 0 : (_ref_current = _ref.current) === null || _ref_current === void 0 ? void 0 : (_ref_current_focus = _ref_current.focus) === null || _ref_current_focus === void 0 ? void 0 : _ref_current_focus.call(_ref_current);
    }, []);
    return _react.default.createElement(_Input.Input, _object_spread({}, shouldShowClearButton && {
        trailingIcon: _react.default.createElement(_media.IconX, {
            "data-testid": "cmpsr.autocomplete.clear-button",
            cursor: "pointer",
            onClick: onReset
        })
    }, inputProps, rest));
};
Autocomplete.Input = AutocompleteInput;
var AutocompleteList = function(_param) {
    var noResultsContent = _param.noResultsContent, renderItem = _param.renderItem, rest = _object_without_properties(_param, [
        "noResultsContent",
        "renderItem"
    ]);
    var _useAutocompleteContext = useAutocompleteContext(), isOpen = _useAutocompleteContext.isOpen, items = _useAutocompleteContext.items, selectedItem = _useAutocompleteContext.selectedItem, highlightedIndex = _useAutocompleteContext.highlightedIndex, getItemProps = _useAutocompleteContext.getItemProps, getMenuProps = _useAutocompleteContext.getMenuProps;
    var styles = (0, _react1.useStyleConfig)("Autocomplete");
    var noResults = noResultsContent !== null && noResultsContent !== void 0 ? noResultsContent : _react.default.createElement(_typography.Text, styles.noResults, "No results");
    return _react.default.createElement(_Box.Box, _object_spread({
        as: "ul",
        visibility: isOpen ? "visible" : "hidden"
    }, styles.list, getMenuProps(), rest), isOpen && items.length ? items.map(function(item, index) {
        return _react.default.createElement(_Box.Box, _object_spread({
            as: "li",
            key: index
        }, styles.item, item === selectedItem && _object_spread({}, styles.item.active), highlightedIndex === index && _object_spread({}, styles.item.highlighted), getItemProps({
            index: index,
            item: item
        })), renderItem(item));
    }) : noResults);
};
Autocomplete.List = AutocompleteList;
